import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Field, FieldDataType } from 'models';
import moment from 'moment';

/** Index field helper service containing functions related to indexer fields. */
@Injectable({ providedIn: 'root' })
export class IndexFieldHelperService {
  /**
   * Gets the value from a field form control.
   *
   * @param control Field form control.
   * @param field Field.
   * @returns The value in the form formatted for saving.
   */
  getFormValue(control: AbstractControl, field: Field): string {
    let value = control.value;
    if (field.type === FieldDataType.date) {
      value = this.getISODate(value);
    }

    // Ensure that undefined is turned to an empty string the API can accept.
    return value ?? '';
  }
  /**
   * Gets an ISO formatted date string from a field value.
   *
   * @param value Field value.
   * @returns An ISO formatted date string.
   */
  getISODate(value: string): string {
    const valueAsMomenet = moment(value);
    const hasNoTime =
      valueAsMomenet.hour() === 0 &&
      valueAsMomenet.minute() === 0 &&
      valueAsMomenet.second() === 0;
    // We drop the time if it is 00:00:00 to prevent time zones from causing dates to be off when stored in the API.
    return hasNoTime
      ? valueAsMomenet.format('YYYY-MM-DD')
      : moment(value).utc().toISOString();
  }
}
